import React from 'react';
import {connect} from 'react-redux';
import {openModal} from '../../../Redux/actions/ui.js';
import {closeModal} from '../../../Redux/actions/ui.js';
import withRouter from '../../../withRouter.js';
import {loadUser,clearUser} from '../../../Redux/actions/user.js';
import axios from '../../../axios-config.js';

class ReAuthorizeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email:"",
      password:"",
      errorMessage:""
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.passwordInput.focus();
    this.passwordInput.select();
  }

  handleSubmit() {
    this.setState({errorMessage:""})
    axios.post('/reauthenticate',{
      token:this.props.token,
      password:this.state.password
    })
    .then((response) => {
      console.log('Success');
      this.props.onLogin(response.data.token);
      this.setState({email:'',password:'',errorMessage:''})
      this.props.closeModal();
    })
    .catch((error) => {
      let apiMessage = error.response && error.response.data && error.response.data.error;
      this.setState({errorMessage:apiMessage ? apiMessage.userMessage : 'Authentication failed. Please try again.'});
    })
  }

  render () {
    let handleKey = (e) => {
      if (e.key === "Enter") {
        this.handleSubmit();
      }
    }

    let handleSignOut = () => {
      this.props.onLogout();
      this.props.closeModal();

    }


    return (
      <div className="SignInForm">
        <div className="SignInFormTitle">Authentication Required</div>
        <div style={{paddingBottom:"10px"}}>{this.props.sessionExpired ? 'Your session has expired.' : 'Your session is about to expire.'} <br /> Please submit your password to continue</div>
        <input style={{marginBottom:"10px"}} ref={(input)=>{this.passwordInput=input}} onKeyPress={handleKey} onChange={(e)=>{this.setState({password:e.target.value})}} value={this.state.password} placeholder="Password" type="password"/>
        {this.state.errorMessage.length !== 0 ? <div className="errorsBoxSignIn"><div>{this.state.errorMessage}</div></div> : null }
        <div className="SignInBottomControls">
          <div className="NewAccountText">All Done? <span className="NewAccountTextRegister" onClick={handleSignOut}>Sign Out</span></div>
          <input onClick={this.handleSubmit} type="button" value="Sign In" className="SignInFormSubmit"></input>
        </div>
      </div>
    )
  }
}

let mapStateToProps = (state) => ({
  token:state.user.token,
  sessionExpired: !!(state.ui.modalOptions && state.ui.modalOptions.sessionExpired)
})


let mapDispatchToProps = dispatch => ({
  closeModal:() => {
    dispatch(closeModal());
  },
  openModal:(value) => {
    dispatch(openModal(value));
  },
  onLogin: (user) => {
    dispatch(loadUser(user));
  },
  onLogout: () => {
    dispatch(clearUser());
  }
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ReAuthorizeForm));
